import React from 'react';
import ReactDOM from 'react-dom';
import { useModal } from '../../shared/contexts/ModalContext';
import styles from './LoginPromptModal.module.css';

const LoginPromptModal = ({ isOpen, onClose, featureName }) => {
  const { openLoginModal, openRegisterModal } = useModal();

  if (!isOpen) return null;

  const handleLogin = () => {
    console.log("LoginPromptModal: 로그인 버튼 클릭됨");
    onClose();
    openLoginModal();
  };

  const handleRegister = () => {
    console.log("LoginPromptModal: 회원가입 버튼 클릭됨");
    onClose();
    openRegisterModal();
  };

  return ReactDOM.createPortal(
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h3 className={styles.modalTitle}>
            {featureName} 회원 전용 기능입니다
          </h3>
          <button className={styles.closeButton} onClick={onClose}>&times;</button>
        </div>
        <div className={`${styles.modalBody} ${styles.loginModalBody}`}>
          <div style={{ fontSize: '50px', marginBottom: '20px' }}>🔒</div>
          <p className={styles.loginModalTextPrimary}>
            로그인하고 모든 기능을 자유롭게 이용해보세요!
          </p>
          <p className={styles.loginModalTextSecondary}>
            학급 관리, 모둠 구성 저장 등 선생님을 위한 유용한 기능들이 제공됩니다.
          </p>
        </div>
        <div className={`${styles.modalFooter} ${styles.loginModalFooter}`}>
          <button className="btn-secondary" onClick={handleRegister}>
            회원가입하기
          </button>
          <button className="btn-primary" onClick={handleLogin}>
            로그인하기
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default LoginPromptModal;
